import React from 'react';
import { Card, Typography, Button, Flex, theme } from 'antd';

const { Title, Text } = Typography;
const { useToken } = theme;

interface ConfirmConnectionProps {
  integration: {
    name: string;
    logo: string;
  };
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmConnection: React.FC<ConfirmConnectionProps> = ({
  integration,
  onCancel,
  onConfirm,
}) => {
  const { token } = useToken();

  return (
    <Card style={{ maxWidth: 600, margin: '0 auto', textAlign: 'center', border: 'none' }}>
      <Flex vertical gap={token.marginLG} align="center">
        <img
          src={integration.logo}
          alt={`${integration.name} Logo`}
          style={{
            width: 64,
            height: 64,
            objectFit: 'contain',
          }}
        />

        <Title level={3} style={{ margin: 0 }}>
          {integration.name} Authentication
        </Title>

        <Text
          style={{
            fontSize: token.fontSizeLG,
            color: token.colorTextSecondary,
            maxWidth: 450,
          }}
        >
          In order to integrate {integration.name} with your Virtual Agent please authorize access
          to your {integration.name} account
        </Text>

        <Flex gap={token.marginMD} style={{ width: '100%' }}>
          <Button size="large" style={{ flex: 1 }} onClick={onCancel}>
            Cancel
          </Button>
          <Button
            type="primary"
            size="large"
            style={{
              flex: 1,
            }}
            onClick={onConfirm}
          >
            Create a connection
          </Button>
        </Flex>
      </Flex>
    </Card>
  );
};
